// Steuerhinweis unter der Summe je Marktsprache, Platzhalter bis zur Freigabe des Wortlauts (Task 186). reference: [1]
import {getLang} from '$m7-library/utils/i18n.js';

// decision: [2]
const TEXTE = {
    de: {mitMwst: '', ohneMwst: ''},
    pl: {mitMwst: '', ohneMwst: ''},
};

/** Hinweis für die Sprache der Seite; '' = nichts anzeigen. */
export function steuerhinweis(ohneMwst) {
    return TEXTE[getLang()]?.[ohneMwst ? 'ohneMwst' : 'mitMwst'] ?? '';
}
